const configProviderContextKey = Symbol();

export { configProviderContextKey };
//# sourceMappingURL=constants.mjs.map
